/**
 * Responsive CSS for Editorial prebuilt blocks.
 * Injected into every generated email so mobile clients stack layouts
 * even when HTML is built without options.isMobile.
 */
export const EDITORIAL_RESPONSIVE_CSS = `
  /* Editorial – Split */
  @media only screen and (max-width: 600px) {
    .editorial-split,
    .editorial-split tbody,
    .editorial-split tr {
      display: block !important;
      width: 100% !important;
      max-width: 100% !important;
    }
    .editorial-split-col {
      display: block !important;
      width: 100% !important;
      max-width: 100% !important;
      box-sizing: border-box !important;
    }
    .editorial-split-image {
      padding: 0 !important;
    }
    .editorial-split-body {
      padding: 32px 20px !important;
    }
    .editorial-split-heading {
      font-size: 32px !important;
      line-height: 1.15 !important;
    }
    .editorial-split-subtitle {
      letter-spacing: 0.12em !important;
      margin-bottom: 10px !important;
    }
    .editorial-split-text {
      font-size: 15px !important;
      line-height: 1.65 !important;
      margin-bottom: 24px !important;
    }

    /* Hero – Overlay */
    .editorial-hero-overlay-bg {
      height: auto !important;
      min-height: 380px !important;
    }
    .editorial-hero-overlay-inner {
      padding: 32px 20px !important;
    }
    .editorial-hero-overlay-title {
      font-size: 36px !important;
      line-height: 0.95 !important;
      word-break: break-word !important;
    }
    .editorial-hero-overlay-text {
      font-size: 16px !important;
      line-height: 1.5 !important;
    }
    .editorial-hero-overlay-btn-wrap {
      margin-top: 24px !important;
    }
    .editorial-hero-overlay-btn-table {
      width: auto !important;
      max-width: 100% !important;
      table-layout: auto !important;
      min-width: 0 !important;
    }
    .editorial-hero-overlay-button {
      display: inline-block !important;
      width: auto !important;
      max-width: 100% !important;
      font-size: 12px !important;
      padding: 10px 24px !important;
      letter-spacing: 0.15em !important;
      line-height: 1.2 !important;
      box-sizing: border-box !important;
    }

    /* Hero – Card */
    .editorial-hero-card-wrap {
      padding-bottom: 32px !important;
    }
    .editorial-hero-card-img-table {
      width: 100% !important;
      max-width: 100% !important;
    }
    .editorial-hero-card-panel {
      width: calc(100% - 32px) !important;
      max-width: 100% !important;
      margin-top: -48px !important;
    }
    .editorial-hero-card-panel td {
      padding: 28px 20px !important;
    }
    .editorial-hero-card-title {
      font-size: 32px !important;
      line-height: 1.1 !important;
    }
    .editorial-hero-card-subtitle {
      letter-spacing: 0.12em !important;
    }

    /* Hero – Editorial */
    .editorial-hero-editorial {
      padding: 48px 20px !important;
    }
    .editorial-hero-editorial-heading {
      font-size: 36px !important;
      line-height: 1.1 !important;
    }
    .editorial-hero-editorial-text {
      font-size: 16px !important;
    }
    .editorial-hero-editorial-img {
      margin: 24px 0 !important;
    }

    /* Editorial – Product */
    .editorial-product-body {
      padding: 40px 20px !important;
    }
    .editorial-product-name {
      font-size: 28px !important;
      line-height: 1.2 !important;
    }
    .editorial-product-price {
      font-size: 20px !important;
    }
    .editorial-product-desc {
      font-size: 15px !important;
      margin-bottom: 28px !important;
    }

    /* Editorial – Quote */
    .editorial-quote-block {
      padding: 48px 20px !important;
    }
    .editorial-quote-text {
      font-size: 28px !important;
      line-height: 1.35 !important;
    }
    .editorial-quote-divider {
      margin-bottom: 24px !important;
    }
  }

  @media only screen and (min-width: 481px) and (max-width: 768px) {
    .editorial-hero-overlay-inner {
      padding: 40px 28px !important;
    }
    .editorial-hero-overlay-title {
      font-size: 42px !important;
      line-height: 0.95 !important;
    }
    .editorial-hero-overlay-btn-table {
      width: auto !important;
      max-width: 100% !important;
      table-layout: auto !important;
    }
    .editorial-hero-overlay-button {
      padding: 10px 28px !important;
    }
  }
`;

/** Mobile typography / spacing used in BlockRenderer (builder canvas). */
export const editorialMobile = {
  split: {
    contentPadding: '32px 20px',
    headingFontSize: '32px',
    textFontSize: '15px',
    subtitleLetterSpacing: '0.12em',
  },
  overlay: {
    heightMultiplier: 0.75,
    minHeight: 380,
    maxHeight: 480,
    fontScale: 0.55,
    minFontSize: 32,
    maxFontSize: 40,
    innerPadding: '32px 20px',
    supportingFontSize: '16px',
  },
  heroCard: {
    cardOffset: '-48px',
    cardWidth: 'calc(100% - 32px)',
    cardMaxWidth: '100%',
    cardPadding: '28px 20px',
    headingFontSize: '32px',
    imageMaxWidth: '100%',
    bottomPadding: '32px',
  },
  heroEditorial: {
    padding: '48px 20px',
    headingFontSize: '36px',
    textFontSize: '16px',
    imageMargin: '24px 0',
  },
  product: {
    contentPadding: '40px 20px',
    nameFontSize: '28px',
    priceFontSize: '20px',
    descFontSize: '15px',
  },
  quote: {
    padding: '48px 20px',
    quoteFontSize: '28px',
    dividerMargin: '0 auto 24px',
  },
} as const;
